import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';

export const DOWNLOAD_WAIVER_TEMPLATE = gql`
  mutation DownloadWaiverTemplate($waiver_id: String!) {
    downloadWaiverTemplate(waiver_id: $waiver_id)
  }
`;

export function useDownloadWaiverTemplate() {
  const [downloadWaiverTemplateMutation, { loading }] = useMutation(
    DOWNLOAD_WAIVER_TEMPLATE
  );

  const downloadWaiverTemplate = useCallback(
    (waiver_id) => {
      return downloadWaiverTemplateMutation({
        variables: { waiver_id },
      });
    },
    [downloadWaiverTemplateMutation]
  );

  return { downloadWaiverTemplate, loading };
}
